(function ($, window) {

	/**
	 * @param {function} [onclick]
	 */
	$.fn.submitbutton = function(onclick) {
		return this.each(function () {
			const $me = $(this);

			$me.click( function(event) {
				event.preventDefault();
				if(onclick) {
					onclick.call($me);
				}
				submitbutton($me);
			});

		});
	};

	/**
	 * @param {string} query
	 * @param {string|function|Object} [post] Selector für Formular, Funktion oder Object
	 * @param {function} [onsuccess]
	 * @param {function} [onerror]
	 * @param {function} [onclick]
	 */
	$.fn.loadbutton = function( query, post, onsuccess, onerror, onclick ) {

		return this.each(function () {

			const $me = $(this);

			const settings = {
				'query': query,
				'post': post,
				'onsuccess': onsuccess,
				'onerror': onerror,
				'onclick': onclick,
			};

			if(settings.query !== null) $me.data('query', settings.query);

			$me.click( function(event) {
				event.preventDefault();
				if(onclick) {
					onclick.call($me);
				}
				loadbutton($me, $me.data('query'), settings.post, settings.onsuccess, settings.onerror);
			});

		});
	};

	/**
	 * @param {string} query
	 * @param {string|function|Object} [post] Selector für Formular, Funktion oder Object
	 * @param {function} [onsuccess]
	 * @param {function} [onerror]
	 */
	$.fn.loadlink = function( query, post, onsuccess, onerror ) {

		return this.each(function () {

			const $me = $(this);

			const settings = {
				'query': query,
				'post': post,
				'onsuccess': onsuccess,
				'onerror': onerror
			};

			if(settings.query !== null) $me.data('query', settings.query);

			$me.click( function(event) {
				event.preventDefault();
				loadlink($me, $me.data('query'), settings.post, settings.onsuccess, settings.onerror);
			});

		});
	};

})(jQuery, window);

function submitbutton($button) {
	if ($button.attr('disabled') === 'disabled') return;

	$button.attr('disabled', 'disabled');

	const $spinner = $('<i class="fa fa-spinner fa-spin" style="margin-right: 0.25em;"></i>');
	$button.prepend($spinner);

	const $icon = $button.find('.fa, .fiv-sqo').not('.fa-spinner');
	$icon.hide();

	$button.closest('form').submit();
}

/**
 * @param {jQuery} $button
 * @param {string} query
 * @param {string|function|Object} [post] Selector für Formular, Funktion oder Object
 * @param {function} [onsuccess]
 * @param {function} [onerror]
 */
function loadbutton( $button, query, post, onsuccess, onerror) {
	if($button.attr('disabled') === 'disabled') return;

	let $btnCaption = $button.find('span').length > 0 ? $button.find('span') : $button;
	let btnLabel = null;
	if(!util.isEmpty($button.data('processlabel'))) {
		btnLabel = $btnCaption.text();
		$btnCaption.text($button.data('processlabel'));
	}

	$button.attr('disabled', 'disabled');

	const $spinner = $('<i class="fa fa-spinner fa-spin" style="margin-right: 0.25em;"></i>');
	$button.prepend($spinner);

	const $icon = $button.find('.fa, .fiv-sqo').not('.fa-spinner');

	$icon.hide();

	let postValues = post;
	if(util.isString(post)) {
		postValues = $(post).serialize();
	} else if(util.isFunction(post)) {
		postValues = post.call($button);
	}

	$.ajax({
		type: 'POST',
		url: (util.strStartsWith(query, '/') ? '' : rootPath) + query,
		data: postValues,
		datatype: 'json',
		timeout:0,
		success: function(data){

			if(data.sessionExpired) {
				window.location.href=util.getUrl("index", {'LOGIN_LOGOUT': '2'});
				return;
			}

			validationaware.updateUiErrors(data);

			$button.css('display', 'inline-block');
			$spinner.remove();
			$icon.css('display', 'inline-block');
			$button.removeAttr('disabled');
			if(btnLabel !== null) {
				$btnCaption.text(btnLabel);
			}
			if(onsuccess) {
				onsuccess.call($button, data);
			}

		},
		error: function(xhr, textStatus, error){

			$button.css('display', 'inline-block');
			$spinner.remove();
			$icon.css('display', 'inline-block');
			$button.removeAttr('disabled');

			if(onerror) {
				onerror.call($button, xhr, textStatus, error);
			}
		}
	});
}

/**
 * @param {jQuery} $link
 * @param {string} query
 * @param {string|function|Object} [post] Selector für Formular, Funktion oder Object
 * @param {function} [onsuccess]
 * @param {function} [onerror]
 */
function loadlink( $link, query, post, onsuccess, onerror) {

	$link.hide();
	const $spinner = $('<i class="fa fa-spinner fa-spin"></i>');
	$link.before($spinner);

	let postValues = post;
	if(util.isString(post)) {
		postValues = $(post).serialize();
	} else if(util.isFunction(post)) {
		postValues = post.call($link);
	}

	$.ajax({
		type: 'POST',
		url: util.getUrl(query),
		data: postValues,
		datatype: 'json',
		timeout:0,
		success: function(data){

			if(data.sessionExpired) {
				window.location.href=util.getUrl("index", {'LOGIN_LOGOUT': '2'});
				return;
			}

			validationaware.updateUiErrors(data);

			$spinner.remove();
			$link.show();

			if(onsuccess) {
				onsuccess.call($link, data);
			}

		},
		error: function(xhr, textStatus, error){

			$spinner.remove();
			$link.show();

			if(onerror) {
				onerror.call($link, xhr, textStatus, error);
			}
		}
	});

}